module.exports = __webpack_public_path__ + "img/photo-0086.e35c7ac1.jpg";